'use client';

import { useEffect } from 'react';
import { initBugsnag, getBugsnagClient } from '@/lib/bugsnag';
import { useCurrentUser } from '@/providers/CurrentUserProvider';

export function BugsnagProvider({ children }: { children: React.ReactNode }) {
  const { user } = useCurrentUser();

  useEffect(() => {
    initBugsnag();
  }, []);

  // Update Bugsnag user context whenever user changes
  useEffect(() => {
    const client = getBugsnagClient();
    if (!client) return;

    if (user) {
      // Set user information in Bugsnag
      client.setUser(user.id, user.email, user.name || undefined);
      console.log('[Bugsnag] User context set:', { id: user.id, email: user.email, name: user.name });
    } else {
      // Clear user information on logout
      client.setUser(undefined, undefined, undefined);
      console.log('[Bugsnag] User context cleared');
    }
  }, [user]);

  return <>{children}</>;
}
